import { useRef } from 'react';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { ImageIcon, Upload, Loader2 } from 'lucide-react';

const OPTIONS = [
  { value: 'none', label: 'Sin logo' },
  { value: 'business', label: 'Del negocio' },
  { value: 'custom', label: 'Subir uno' }
];

export const LogoPicker = ({ source, onSource, hasBusinessLogo, customPreview, uploading, onUpload }) => {
  const inputRef = useRef(null);
  return (
    <div className="space-y-2" data-testid="qr-logo-picker">
      <Label className="text-sm flex items-center gap-2"><ImageIcon className="w-4 h-4" />Logo en los carteles</Label>
      <div className="grid grid-cols-3 gap-2">
        {OPTIONS.map(o => {
          const disabled = o.value === 'business' && !hasBusinessLogo;
          return (
            <button key={o.value} type="button" disabled={disabled} data-testid={`qr-logo-source-${o.value}`}
              onClick={() => onSource(o.value)}
              className={`py-2 px-1 rounded-md border-2 text-xs font-medium transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${source === o.value ? 'border-primary bg-primary/10' : 'border-border hover:border-primary/40'}`}>
              {o.label}
            </button>
          );
        })}
      </div>
      {!hasBusinessLogo && (
        <p className="text-[11px] text-muted-foreground" data-testid="qr-logo-no-business">Tu negocio todavía no tiene logo cargado.</p>
      )}
      {source === 'custom' && (
        <div className="flex items-center gap-3">
          <div className="w-14 h-14 rounded-md border bg-muted flex items-center justify-center overflow-hidden">
            {customPreview
              ? <img src={customPreview} alt="Logo" className="max-w-full max-h-full object-contain" data-testid="qr-logo-preview" />
              : <ImageIcon className="w-5 h-5 text-muted-foreground" />}
          </div>
          <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" data-testid="qr-logo-file-input"
            onChange={(e) => { const f = e.target.files?.[0]; if (f) onUpload(f); e.target.value = ''; }} />
          <Button variant="outline" size="sm" disabled={uploading} onClick={() => inputRef.current?.click()} data-testid="qr-logo-upload-btn">
            {uploading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Upload className="w-4 h-4 mr-2" />}
            {customPreview ? 'Cambiar' : 'Elegir imagen'}
          </Button>
        </div>
      )}
    </div>
  );
};
